import { action, observable, computed } from 'mobx';

import ChatWallService from 'services/ChatWallService';
import createMessagingService from 'services/MessagingService/MessagingService';
import {
  GET_CHAT_WALL_COMMENTS,
  DELETE_COMMENT_RESPONSE_STATE,
  GET_CHAT_WALL_VISIBILITY,
} from 'services/MessagingService/EventNames';
import APIStates from 'enum/APIStates';


const MAX_COMMENTS_PER_PAGE = 8;

class ChatWallStore {
  constructor(createMessagingService) {
    this.messagingService = createMessagingService();
    this.messagingService.on(GET_CHAT_WALL_COMMENTS, this._getComments);
    this.messagingService.on(GET_CHAT_WALL_VISIBILITY, this._handleVisibilityChatWall);
    this.messagingService.on(DELETE_COMMENT_RESPONSE_STATE, this._handleDeleteCommentResponseStatus);
  }

  destructor() {
    this.messagingService.off(GET_CHAT_WALL_COMMENTS, this._getComments);
    this.messagingService.off(GET_CHAT_WALL_VISIBILITY, this._handleVisibilityChatWall);
    this.messagingService.off(DELETE_COMMENT_RESPONSE_STATE, this._handleDeleteCommentResponseStatus);
  }

  @observable comments = [];
  @observable deleteCommentResponseStatus = APIStates.INITIAL;
  @observable currentPage = 0;
  @observable isCommentsPageVisible = true;
  @observable showComments = true;

  _getComments = (comments) => {
    this.comments = comments;
  };

  _handleVisibilityChatWall = (visibility) => {
    this.isCommentsPageVisible = visibility;
    this.showComments = visibility;
  };

  _handleDeleteCommentResponseStatus = (status) => {
    this.setDeleteCommentResponseStatus(status);
  };

  @action setChatWallCommentsVisibility = (username, isVisible) => {
    this.showComments = isVisible;
    this.isCommentsPageVisible = isVisible;
    ChatWallService.toggleVisibilityChatWall(username, isVisible);
  };

  @action getShowComments(username) {
    ChatWallService.getShowComments(username);
  }

  @action getComments(username) {
    ChatWallService.getComments(username);
  }

  @action submitComment(comment, username) {
    ChatWallService.submitComment(comment, username);
  }

  @action deleteComment(username, comment) {
    ChatWallService.deleteComment(username, comment);
  }

  @action setDeleteCommentResponseStatus = (status) => {
    this.deleteCommentResponseStatus = status;
  };

  @action changePageNumber = (number) => {
    this.currentPage = number;
  };

  @computed get isThereAnyComment() {
    return this.comments.length > 0;
  }

  @computed get isDeleteButtonLoading() {
    return this.deleteCommentResponseStatus === APIStates.PENDING;
  }

  @computed get totalPages() {
    return this.comments.length / MAX_COMMENTS_PER_PAGE;
  }

  @computed get visibleCommentsOnPage() {
    const sliceTo = this.currentPage === 0 ? MAX_COMMENTS_PER_PAGE : (this.currentPage + 1) * MAX_COMMENTS_PER_PAGE;
    const sliceFrom = this.currentPage * MAX_COMMENTS_PER_PAGE;

    return this.comments.slice(sliceFrom, sliceTo);
  }
}

export default new ChatWallStore(createMessagingService);
